module.exports = __webpack_public_path__ + "ad97afd3337e8cda302d10ff5a4026b8.ttf";